import * as core from '../../../../../../../core'

import { query } from './subawards-table.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.subawards.widgets.subawards',
    description: 'Subawards',
    name: 'Subawards',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
